export class EsTransactionBaseData {
  procedureInstanceId?: number;
}
